/**
 * @deprecated Use `getMetaCsrfToken` from `@socrata/platform/api` instead.
 */
export default () => {
  const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
  const csrfToken = csrfTokenMeta && csrfTokenMeta.getAttribute('content');

  return csrfToken;
};
